var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 177,
    height: 213,
    viewBox: "0 0 177 213",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b,.c{fill:#fff}.c{opacity:.548}"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-466 -216)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 177,
    height: 213,
    rx: 88.5,
    style: {
      fill: "#21549b"
    },
    transform: "translate(466 216)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(499 259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.587 37.134a6.04 6.04 0 0 0-6 6v43.183a6.04 6.04 0 0 0 6 6h64.778a6.04 6.04 0 0 0 6-6V43.134a6.04 6.04 0 0 0-6-6Zm0 4.8h64.778a1.147 1.147 0 0 1 1.2 1.2v43.183a1.147 1.147 0 0 1-1.2 1.2H39.587a1.147 1.147 0 0 1-1.2-1.2V43.134a1.147 1.147 0 0 1 1.2-1.2m-37.187 6a2.4 2.4 0 1 0 0 4.8h23.991a2.4 2.4 0 0 0 0-4.8Zm46.521 1.162a2.4 2.4 0 0 0-1.421 4.12l12.07 12-12 10.909a2.403 2.403 0 0 0 3.2 3.586l.026-.024 12.183-11.1 3.636 3.6a7.623 7.623 0 0 0 10.685 0l3.636-3.6 12.22 11.1a2.402 2.402 0 0 0 3.251-3.538l-.026-.024-12.034-10.951 12.107-11.959a2.4 2.4 0 1 0-3.307-3.476l-.066.066-19.193 18.968a3.225 3.225 0 0 1-3.9 0L50.87 49.805a2.4 2.4 0 0 0-1.949-.712ZM7.2 62.325a2.4 2.4 0 0 0 0 4.8h19.191a2.4 2.4 0 0 0 0-4.8Zm4.8 14.4a2.4 2.4 0 1 0 0 4.8h14.4a2.4 2.4 0 0 0 0-4.8Z",
    className: "b"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.697,
    cy: 5.697,
    r: 5.697,
    className: "c",
    transform: "matrix(-1 0 0 -1 79.386 126.685)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.841,
    cy: 8.841,
    r: 8.841,
    className: "c",
    transform: "matrix(-1 0 0 -1 34.667 19.08)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.505,
    cy: 1.505,
    r: 1.505,
    className: "c",
    transform: "matrix(-1 0 0 -1 63.315 20.478)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.413,
    cy: 4.413,
    r: 4.413,
    className: "c",
    transform: "matrix(-1 0 0 -1 27.907 114.335)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.462,
    cy: 2.462,
    r: 2.462,
    className: "b",
    transform: "matrix(-1 0 0 -1 38.056 119.019)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.697,
    cy: 5.697,
    r: 5.697,
    className: "b",
    transform: "matrix(-1 0 0 -1 76.591 16.285)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.505,
    cy: 1.505,
    r: 1.505,
    className: "c",
    transform: "matrix(-1 0 0 -1 63.315 109.216)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.252,
    cy: 3.252,
    r: 3.252,
    className: "c",
    transform: "matrix(-1 0 0 -1 52.136 6.503)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.462,
    cy: 2.462,
    r: 2.462,
    className: "b",
    transform: "rotate(-90 106.37 9.093)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.854,
    cy: 1.854,
    r: 1.854,
    className: "c",
    transform: "matrix(-1 0 0 -1 20.693 38.645)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.462,
    cy: 2.462,
    r: 2.462,
    className: "b",
    transform: "rotate(-90 12.74 6.298)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactMail);
export default __webpack_public_path__ + "static/media/contactMail.a4db0e8b6ace317f477c6a57c651dd6f.svg";
export { ForwardRef as ReactComponent };